import M, { forwardRef as T, createContext as wr, useState as Sr, useRef as _r, useCallback as oe, useContext as Pr } from "react";
import { useBlockNoteContext as Cr, ComponentsContext as Or, BlockNoteViewRaw as Fr } from "@blocknote/react";
import * as d from "@mantine/core";
import { MantineProvider as Mr } from "@mantine/core";
import Dr from "use-prefers-color-scheme";
import { assertEmpty as R, isSafari as ae } from "@blocknote/core";
import { useFocusWithin as Nr, useFocusTrap as Ir, mergeRefs as Lr } from "@mantine/hooks";
var ie = { exports: {} }, B = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fe;
function Ar() {
  if (Fe)
    return B;
  Fe = 1;
  var r = M, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, s = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(u, b, p) {
    var y, w = {}, P = null, W = null;
    p !== void 0 && (P = "" + p), b.key !== void 0 && (P = "" + b.key), b.ref !== void 0 && (W = b.ref);
    for (y in b)
      o.call(b, y) && !c.hasOwnProperty(y) && (w[y] = b[y]);
    if (u && u.defaultProps)
      for (y in b = u.defaultProps, b)
        w[y] === void 0 && (w[y] = b[y]);
    return { $$typeof: t, type: u, key: P, ref: W, props: w, _owner: s.current };
  }
  return B.Fragment = n, B.jsx = f, B.jsxs = f, B;
}
var $ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Me;
function zr() {
  return Me || (Me = 1, process.env.NODE_ENV !== "production" && function() {
    var r = M, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), u = Symbol.for("react.context"), b = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), W = Symbol.for("react.offscreen"), se = Symbol.iterator, Ue = "@@iterator";
    function Ge(e) {
      if (e === null || typeof e != "object")
        return null;
      var a = se && e[se] || e[Ue];
      return typeof a == "function" ? a : null;
    }
    var N = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(e) {
      {
        for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), v = 1; v < a; v++)
          i[v - 1] = arguments[v];
        He("error", e, i);
      }
    }
    function He(e, a, i) {
      {
        var v = N.ReactDebugCurrentFrame, h = v.getStackAddendum();
        h !== "" && (a += "%s", i = i.concat([h]));
        var j = i.map(function(g) {
          return String(g);
        });
        j.unshift("Warning: " + a), Function.prototype.apply.call(console[e], console, j);
      }
    }
    var Ke = !1, qe = !1, Je = !1, Xe = !1, Ze = !1, le;
    le = Symbol.for("react.module.reference");
    function Qe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === o || e === c || Ze || e === s || e === p || e === y || Xe || e === W || Ke || qe || Je || typeof e == "object" && e !== null && (e.$$typeof === P || e.$$typeof === w || e.$$typeof === f || e.$$typeof === u || e.$$typeof === b || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === le || e.getModuleId !== void 0));
    }
    function er(e, a, i) {
      var v = e.displayName;
      if (v)
        return v;
      var h = a.displayName || a.name || "";
      return h !== "" ? i + "(" + h + ")" : i;
    }
    function ue(e) {
      return e.displayName || "Context";
    }
    function O(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case c:
          return "Profiler";
        case s:
          return "StrictMode";
        case p:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case u:
            var a = e;
            return ue(a) + ".Consumer";
          case f:
            var i = e;
            return ue(i._context) + ".Provider";
          case b:
            return er(e, e.render, "ForwardRef");
          case w:
            var v = e.displayName || null;
            return v !== null ? v : O(e.type) || "Memo";
          case P: {
            var h = e, j = h._payload, g = h._init;
            try {
              return O(g(j));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, A = 0, ce, de, fe, ve, be, pe, me;
    function ge() {
    }
    ge.__reactDisabledLog = !0;
    function rr() {
      {
        if (A === 0) {
          ce = console.log, de = console.info, fe = console.warn, ve = console.error, be = console.group, pe = console.groupCollapsed, me = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        A++;
      }
    }
    function tr() {
      {
        if (A--, A === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, e, {
              value: ce
            }),
            info: D({}, e, {
              value: de
            }),
            warn: D({}, e, {
              value: fe
            }),
            error: D({}, e, {
              value: ve
            }),
            group: D({}, e, {
              value: be
            }),
            groupCollapsed: D({}, e, {
              value: pe
            }),
            groupEnd: D({}, e, {
              value: me
            })
          });
        }
        A < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = N.ReactCurrentDispatcher, X;
    function V(e, a, i) {
      {
        if (X === void 0)
          try {
            throw Error();
          } catch (h) {
            var v = h.stack.trim().match(/\n( *(at )?)/);
            X = v && v[1] || "";
          }
        return `
` + X + e;
      }
    }
    var Z = !1, Y;
    {
      var nr = typeof WeakMap == "function" ? WeakMap : Map;
      Y = new nr();
    }
    function he(e, a) {
      if (!e || Z)
        return "";
      {
        var i = Y.get(e);
        if (i !== void 0)
          return i;
      }
      var v;
      Z = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var j;
      j = J.current, J.current = null, rr();
      try {
        if (a) {
          var g = function() {
            throw Error();
          };
          if (Object.defineProperty(g.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(g, []);
            } catch (F) {
              v = F;
            }
            Reflect.construct(e, [], g);
          } else {
            try {
              g.call();
            } catch (F) {
              v = F;
            }
            e.call(g.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            v = F;
          }
          e();
        }
      } catch (F) {
        if (F && v && typeof F.stack == "string") {
          for (var m = F.stack.split(`
`), _ = v.stack.split(`
`), E = m.length - 1, k = _.length - 1; E >= 1 && k >= 0 && m[E] !== _[k]; )
            k--;
          for (; E >= 1 && k >= 0; E--, k--)
            if (m[E] !== _[k]) {
              if (E !== 1 || k !== 1)
                do
                  if (E--, k--, k < 0 || m[E] !== _[k]) {
                    var C = `
` + m[E].replace(" at new ", " at ");
                    return e.displayName && C.includes("<anonymous>") && (C = C.replace("<anonymous>", e.displayName)), typeof e == "function" && Y.set(e, C), C;
                  }
                while (E >= 1 && k >= 0);
              break;
            }
        }
      } finally {
        Z = !1, J.current = j, tr(), Error.prepareStackTrace = h;
      }
      var L = e ? e.displayName || e.name : "", Oe = L ? V(L) : "";
      return typeof e == "function" && Y.set(e, Oe), Oe;
    }
    function or(e, a, i) {
      return he(e, !1);
    }
    function ar(e) {
      var a = e.prototype;
      return !!(a && a.isReactComponent);
    }
    function U(e, a, i) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return he(e, ar(e));
      if (typeof e == "string")
        return V(e);
      switch (e) {
        case p:
          return V("Suspense");
        case y:
          return V("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case b:
            return or(e.render);
          case w:
            return U(e.type, a, i);
          case P: {
            var v = e, h = v._payload, j = v._init;
            try {
              return U(j(h), a, i);
            } catch {
            }
          }
        }
      return "";
    }
    var G = Object.prototype.hasOwnProperty, xe = {}, ye = N.ReactDebugCurrentFrame;
    function H(e) {
      if (e) {
        var a = e._owner, i = U(e.type, e._source, a ? a.type : null);
        ye.setExtraStackFrame(i);
      } else
        ye.setExtraStackFrame(null);
    }
    function ir(e, a, i, v, h) {
      {
        var j = Function.call.bind(G);
        for (var g in e)
          if (j(e, g)) {
            var m = void 0;
            try {
              if (typeof e[g] != "function") {
                var _ = Error((v || "React class") + ": " + i + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              m = e[g](a, g, v, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (E) {
              m = E;
            }
            m && !(m instanceof Error) && (H(h), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", i, g, typeof m), H(null)), m instanceof Error && !(m.message in xe) && (xe[m.message] = !0, H(h), S("Failed %s type: %s", i, m.message), H(null));
          }
      }
    }
    var sr = Array.isArray;
    function Q(e) {
      return sr(e);
    }
    function lr(e) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, i = a && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return i;
      }
    }
    function ur(e) {
      try {
        return je(e), !1;
      } catch {
        return !0;
      }
    }
    function je(e) {
      return "" + e;
    }
    function Re(e) {
      if (ur(e))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", lr(e)), je(e);
    }
    var z = N.ReactCurrentOwner, cr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Te, Ee, ee;
    ee = {};
    function dr(e) {
      if (G.call(e, "ref")) {
        var a = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function fr(e) {
      if (G.call(e, "key")) {
        var a = Object.getOwnPropertyDescriptor(e, "key").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function vr(e, a) {
      if (typeof e.ref == "string" && z.current && a && z.current.stateNode !== a) {
        var i = O(z.current.type);
        ee[i] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(z.current.type), e.ref), ee[i] = !0);
      }
    }
    function br(e, a) {
      {
        var i = function() {
          Te || (Te = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        i.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function pr(e, a) {
      {
        var i = function() {
          Ee || (Ee = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        i.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var mr = function(e, a, i, v, h, j, g) {
      var m = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: a,
        ref: i,
        props: g,
        // Record the component responsible for creating this element.
        _owner: j
      };
      return m._store = {}, Object.defineProperty(m._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(m, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(m, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.freeze && (Object.freeze(m.props), Object.freeze(m)), m;
    };
    function gr(e, a, i, v, h) {
      {
        var j, g = {}, m = null, _ = null;
        i !== void 0 && (Re(i), m = "" + i), fr(a) && (Re(a.key), m = "" + a.key), dr(a) && (_ = a.ref, vr(a, h));
        for (j in a)
          G.call(a, j) && !cr.hasOwnProperty(j) && (g[j] = a[j]);
        if (e && e.defaultProps) {
          var E = e.defaultProps;
          for (j in E)
            g[j] === void 0 && (g[j] = E[j]);
        }
        if (m || _) {
          var k = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          m && br(g, k), _ && pr(g, k);
        }
        return mr(e, m, _, h, v, z.current, g);
      }
    }
    var re = N.ReactCurrentOwner, ke = N.ReactDebugCurrentFrame;
    function I(e) {
      if (e) {
        var a = e._owner, i = U(e.type, e._source, a ? a.type : null);
        ke.setExtraStackFrame(i);
      } else
        ke.setExtraStackFrame(null);
    }
    var te;
    te = !1;
    function ne(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function we() {
      {
        if (re.current) {
          var e = O(re.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function hr(e) {
      {
        if (e !== void 0) {
          var a = e.fileName.replace(/^.*[\\\/]/, ""), i = e.lineNumber;
          return `

Check your code at ` + a + ":" + i + ".";
        }
        return "";
      }
    }
    var Se = {};
    function xr(e) {
      {
        var a = we();
        if (!a) {
          var i = typeof e == "string" ? e : e.displayName || e.name;
          i && (a = `

Check the top-level render call using <` + i + ">.");
        }
        return a;
      }
    }
    function _e(e, a) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var i = xr(a);
        if (Se[i])
          return;
        Se[i] = !0;
        var v = "";
        e && e._owner && e._owner !== re.current && (v = " It was passed a child from " + O(e._owner.type) + "."), I(e), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, v), I(null);
      }
    }
    function Pe(e, a) {
      {
        if (typeof e != "object")
          return;
        if (Q(e))
          for (var i = 0; i < e.length; i++) {
            var v = e[i];
            ne(v) && _e(v, a);
          }
        else if (ne(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var h = Ge(e);
          if (typeof h == "function" && h !== e.entries)
            for (var j = h.call(e), g; !(g = j.next()).done; )
              ne(g.value) && _e(g.value, a);
        }
      }
    }
    function yr(e) {
      {
        var a = e.type;
        if (a == null || typeof a == "string")
          return;
        var i;
        if (typeof a == "function")
          i = a.propTypes;
        else if (typeof a == "object" && (a.$$typeof === b || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        a.$$typeof === w))
          i = a.propTypes;
        else
          return;
        if (i) {
          var v = O(a);
          ir(i, e.props, "prop", v, e);
        } else if (a.PropTypes !== void 0 && !te) {
          te = !0;
          var h = O(a);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", h || "Unknown");
        }
        typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function jr(e) {
      {
        for (var a = Object.keys(e.props), i = 0; i < a.length; i++) {
          var v = a[i];
          if (v !== "children" && v !== "key") {
            I(e), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), I(null);
            break;
          }
        }
        e.ref !== null && (I(e), S("Invalid attribute `ref` supplied to `React.Fragment`."), I(null));
      }
    }
    function Ce(e, a, i, v, h, j) {
      {
        var g = Qe(e);
        if (!g) {
          var m = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (m += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = hr(h);
          _ ? m += _ : m += we();
          var E;
          e === null ? E = "null" : Q(e) ? E = "array" : e !== void 0 && e.$$typeof === t ? (E = "<" + (O(e.type) || "Unknown") + " />", m = " Did you accidentally export a JSX literal instead of a component?") : E = typeof e, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, m);
        }
        var k = gr(e, a, i, h, j);
        if (k == null)
          return k;
        if (g) {
          var C = a.children;
          if (C !== void 0)
            if (v)
              if (Q(C)) {
                for (var L = 0; L < C.length; L++)
                  Pe(C[L], e);
                Object.freeze && Object.freeze(C);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Pe(C, e);
        }
        return e === o ? jr(k) : yr(k), k;
      }
    }
    function Rr(e, a, i) {
      return Ce(e, a, i, !0);
    }
    function Tr(e, a, i) {
      return Ce(e, a, i, !1);
    }
    var Er = Tr, kr = Rr;
    $.Fragment = o, $.jsx = Er, $.jsxs = kr;
  }()), $;
}
process.env.NODE_ENV === "production" ? ie.exports = Ar() : ie.exports = zr();
var l = ie.exports;
const Be = (r, t, n = !1) => {
  const o = [];
  function s(c, f = "--bn") {
    for (const u in c) {
      const b = u.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), p = `${f}-${b}`;
      typeof c[u] != "object" ? (typeof c[u] == "number" && (c[u] = `${c[u]}px`), n ? t.style.removeProperty(p) : t.style.setProperty(p, c[u].toString())) : s(c[u], p);
    }
  }
  return s(r), o;
}, De = (r, t) => Be(r, t), Br = {
  colors: {
    editor: {
      text: void 0,
      background: void 0
    },
    menu: {
      text: void 0,
      background: void 0
    },
    tooltip: {
      text: void 0,
      background: void 0
    },
    hovered: {
      text: void 0,
      background: void 0
    },
    selected: {
      text: void 0,
      background: void 0
    },
    disabled: {
      text: void 0,
      background: void 0
    },
    shadow: void 0,
    border: void 0,
    sideMenu: void 0,
    highlights: {
      gray: {
        text: void 0,
        background: void 0
      },
      brown: {
        text: void 0,
        background: void 0
      },
      red: {
        text: void 0,
        background: void 0
      },
      orange: {
        text: void 0,
        background: void 0
      },
      yellow: {
        text: void 0,
        background: void 0
      },
      green: {
        text: void 0,
        background: void 0
      },
      blue: {
        text: void 0,
        background: void 0
      },
      purple: {
        text: void 0,
        background: void 0
      },
      pink: {
        text: void 0,
        background: void 0
      }
    }
  },
  borderRadius: void 0,
  fontFamily: void 0
}, $r = (r) => Be(Br, r, !0), Wr = T((r, t) => {
  const {
    className: n,
    name: o,
    label: s,
    icon: c,
    value: f,
    autoFocus: u,
    placeholder: b,
    onKeyDown: p,
    onChange: y,
    onSubmit: w,
    ...P
  } = r;
  return R(P), /* @__PURE__ */ l.jsx(
    d.TextInput,
    {
      size: "xs",
      className: n,
      ref: t,
      name: o,
      label: s,
      leftSection: c,
      value: f,
      autoFocus: u,
      "data-autofocus": u ? "true" : void 0,
      placeholder: b,
      onKeyDown: p,
      onChange: y,
      onSubmit: w
    }
  );
});
var $e = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Ne = M.createContext && /* @__PURE__ */ M.createContext($e), Vr = ["attr", "size", "title"];
function Yr(r, t) {
  if (r == null)
    return {};
  var n = Ur(r, t), o, s;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(r);
    for (s = 0; s < c.length; s++)
      o = c[s], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(r, o) && (n[o] = r[o]);
  }
  return n;
}
function Ur(r, t) {
  if (r == null)
    return {};
  var n = {};
  for (var o in r)
    if (Object.prototype.hasOwnProperty.call(r, o)) {
      if (t.indexOf(o) >= 0)
        continue;
      n[o] = r[o];
    }
  return n;
}
function K() {
  return K = Object.assign ? Object.assign.bind() : function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    }
    return r;
  }, K.apply(this, arguments);
}
function Ie(r, t) {
  var n = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(r);
    t && (o = o.filter(function(s) {
      return Object.getOwnPropertyDescriptor(r, s).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function q(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ie(Object(n), !0).forEach(function(o) {
      Gr(r, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(n)) : Ie(Object(n)).forEach(function(o) {
      Object.defineProperty(r, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return r;
}
function Gr(r, t, n) {
  return t = Hr(t), t in r ? Object.defineProperty(r, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = n, r;
}
function Hr(r) {
  var t = Kr(r, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Kr(r, t) {
  if (typeof r != "object" || !r)
    return r;
  var n = r[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(r, t || "default");
    if (typeof o != "object")
      return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(r);
}
function We(r) {
  return r && r.map((t, n) => /* @__PURE__ */ M.createElement(t.tag, q({
    key: n
  }, t.attr), We(t.child)));
}
function Ve(r) {
  return (t) => /* @__PURE__ */ M.createElement(qr, K({
    attr: q({}, r.attr)
  }, t), We(r.child));
}
function qr(r) {
  var t = (n) => {
    var {
      attr: o,
      size: s,
      title: c
    } = r, f = Yr(r, Vr), u = s || n.size || "1em", b;
    return n.className && (b = n.className), r.className && (b = (b ? b + " " : "") + r.className), /* @__PURE__ */ M.createElement("svg", K({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, o, f, {
      className: b,
      style: q(q({
        color: r.color || n.color
      }, n.style), r.style),
      height: u,
      width: u,
      xmlns: "http://www.w3.org/2000/svg"
    }), c && /* @__PURE__ */ M.createElement("title", null, c), r.children);
  };
  return Ne !== void 0 ? /* @__PURE__ */ M.createElement(Ne.Consumer, null, (n) => t(n)) : t($e);
}
function Jr(r) {
  return Ve({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z", clipRule: "evenodd" }, child: [] }] })(r);
}
function Xr(r) {
  return Ve({ tag: "svg", attr: { viewBox: "0 0 20 20", fill: "currentColor", "aria-hidden": "true" }, child: [{ tag: "path", attr: { fillRule: "evenodd", d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z", clipRule: "evenodd" }, child: [] }] })(r);
}
const Ye = wr(void 0), Zr = T((r, t) => {
  const {
    children: n,
    onOpenChange: o,
    position: s,
    sub: c,
    // not used
    ...f
  } = r;
  R(f);
  const [u, b] = Sr(!1), p = _r(), y = oe(() => {
    p.current && clearTimeout(p.current), p.current = setTimeout(() => {
      b(!1);
    }, 250);
  }, []), w = oe(() => {
    p.current && clearTimeout(p.current), b(!0);
  }, []);
  return /* @__PURE__ */ l.jsx(
    Ye.Provider,
    {
      value: {
        onMenuMouseOver: w,
        onMenuMouseLeave: y
      },
      children: /* @__PURE__ */ l.jsx(
        d.Menu.Item,
        {
          className: "bn-menu-item bn-mt-sub-menu-item",
          ref: t,
          onMouseOver: w,
          onMouseLeave: y,
          children: /* @__PURE__ */ l.jsx(
            d.Menu,
            {
              withinPortal: !1,
              middlewares: { flip: !0, shift: !0, inline: !1, size: !0 },
              trigger: "hover",
              opened: u,
              onClose: () => o == null ? void 0 : o(!1),
              onOpen: () => o == null ? void 0 : o(!0),
              position: s,
              children: n
            }
          )
        }
      )
    }
  );
}), Qr = (r) => {
  const { children: t, onOpenChange: n, position: o, sub: s, ...c } = r;
  return R(c), s ? /* @__PURE__ */ l.jsx(Zr, { ...r }) : /* @__PURE__ */ l.jsx(
    d.Menu,
    {
      withinPortal: !1,
      middlewares: { flip: !0, shift: !0, inline: !1, size: !0 },
      onClose: () => n == null ? void 0 : n(!1),
      onOpen: () => n == null ? void 0 : n(!0),
      position: o,
      children: t
    }
  );
}, et = T((r, t) => {
  const { className: n, children: o, icon: s, checked: c, subTrigger: f, onClick: u, ...b } = r;
  return R(b, !1), f ? /* @__PURE__ */ l.jsxs("div", { ref: t, ...b, children: [
    o,
    /* @__PURE__ */ l.jsx(Xr, { size: 15 })
  ] }) : /* @__PURE__ */ l.jsx(
    d.Menu.Item,
    {
      className: n,
      ref: t,
      leftSection: s,
      rightSection: c ? /* @__PURE__ */ l.jsx(d.CheckIcon, { size: 10 }) : c === !1 ? /* @__PURE__ */ l.jsx("div", { className: "bn-tick-space" }) : null,
      onClick: u,
      ...b,
      children: o
    }
  );
}), rt = (r) => {
  const {
    children: t,
    sub: n,
    // unused
    ...o
  } = r;
  return R(o), /* @__PURE__ */ l.jsx(d.Menu.Target, { children: t });
}, tt = T((r, t) => {
  const {
    className: n,
    children: o,
    sub: s,
    //unused
    ...c
  } = r;
  R(c);
  const f = Pr(Ye);
  return /* @__PURE__ */ l.jsx(
    d.Menu.Dropdown,
    {
      className: n,
      ref: t,
      onMouseOver: f == null ? void 0 : f.onMenuMouseOver,
      onMouseLeave: f == null ? void 0 : f.onMenuMouseLeave,
      children: o
    }
  );
}), nt = T((r, t) => {
  const { className: n, ...o } = r;
  return R(o), /* @__PURE__ */ l.jsx(d.Menu.Divider, { className: n, ref: t });
}), ot = T((r, t) => {
  const { className: n, children: o, ...s } = r;
  return R(s), /* @__PURE__ */ l.jsx(d.Menu.Label, { className: n, ref: t, children: o });
}), at = T((r, t) => {
  const {
    className: n,
    tabs: o,
    defaultOpenTab: s,
    openTab: c,
    setOpenTab: f,
    loading: u,
    ...b
  } = r;
  return R(b), /* @__PURE__ */ l.jsx(d.Group, { className: n, ref: t, children: /* @__PURE__ */ l.jsxs(
    d.Tabs,
    {
      value: c,
      defaultValue: s,
      onChange: f,
      children: [
        u && /* @__PURE__ */ l.jsx(d.LoadingOverlay, { visible: u }),
        /* @__PURE__ */ l.jsx(d.Tabs.List, { children: o.map((p) => /* @__PURE__ */ l.jsx(
          d.Tabs.Tab,
          {
            "data-test": `${p.name.toLowerCase()}-tab`,
            value: p.name,
            children: p.name
          },
          p.name
        )) }),
        o.map((p) => /* @__PURE__ */ l.jsx(d.Tabs.Panel, { value: p.name, children: p.tabPanel }, p.name))
      ]
    }
  ) });
}), it = T((r, t) => {
  const { className: n, children: o, onClick: s, label: c, ...f } = r;
  return R(f), /* @__PURE__ */ l.jsx(
    d.Button,
    {
      size: "xs",
      "aria-label": c,
      className: n,
      ref: t,
      onClick: s,
      ...f,
      children: o
    }
  );
}), st = T((r, t) => {
  const { className: n, accept: o, value: s, placeholder: c, onChange: f, ...u } = r;
  return R(u), /* @__PURE__ */ l.jsx(
    d.FileInput,
    {
      size: "xs",
      className: n,
      ref: t,
      accept: o,
      value: s,
      placeholder: c,
      onChange: f,
      ...u
    }
  );
}), lt = T((r, t) => {
  const { className: n, children: o, ...s } = r;
  return R(s), /* @__PURE__ */ l.jsx("div", { className: n, ref: t, children: o });
}), ut = T((r, t) => {
  const { className: n, value: o, placeholder: s, onKeyDown: c, onChange: f, ...u } = r;
  return R(u), /* @__PURE__ */ l.jsx(
    d.TextInput,
    {
      size: "xs",
      "data-test": "embed-input",
      className: n,
      ref: t,
      value: o,
      placeholder: s,
      onKeyDown: c,
      onChange: f
    }
  );
}), ct = (r) => {
  const { children: t, opened: n, position: o, ...s } = r;
  return R(s), /* @__PURE__ */ l.jsx(
    d.Popover,
    {
      withinPortal: !1,
      zIndex: 1e4,
      opened: n,
      position: o,
      children: t
    }
  );
}, dt = (r) => {
  const { children: t, ...n } = r;
  return R(n), /* @__PURE__ */ l.jsx(d.PopoverTarget, { children: t });
}, ft = T((r, t) => {
  const {
    className: n,
    children: o,
    variant: s,
    // unused
    ...c
  } = r;
  return R(c), /* @__PURE__ */ l.jsx(d.PopoverDropdown, { className: n, ref: t, children: o });
}), vt = T((r, t) => {
  const { className: n, children: o, ...s } = r;
  return R(s), /* @__PURE__ */ l.jsx(d.Group, { align: "center", gap: 0, className: n, ref: t, children: o });
}), bt = T((r, t) => {
  const {
    className: n,
    children: o,
    icon: s,
    onClick: c,
    onDragEnd: f,
    onDragStart: u,
    draggable: b,
    label: p,
    ...y
  } = r;
  return R(y, !1), s ? /* @__PURE__ */ l.jsx(
    d.ActionIcon,
    {
      size: 24,
      className: n,
      ref: t,
      onClick: c,
      onDragEnd: f,
      onDragStart: u,
      draggable: b,
      "aria-label": p,
      ...y,
      children: s
    }
  ) : /* @__PURE__ */ l.jsx(
    d.Button,
    {
      className: n,
      ref: t,
      onClick: c,
      onDragEnd: f,
      onDragStart: u,
      draggable: b,
      "aria-label": p,
      ...y,
      children: o
    }
  );
}), pt = T((r, t) => {
  const { className: n, children: o, id: s, ...c } = r;
  return R(c), /* @__PURE__ */ l.jsx(
    d.Stack,
    {
      gap: 0,
      className: n,
      ref: t,
      id: s,
      role: "listbox",
      children: o
    }
  );
}), mt = T((r, t) => {
  const { className: n, children: o, ...s } = r;
  return R(s), /* @__PURE__ */ l.jsx(d.Group, { className: n, ref: t, children: /* @__PURE__ */ l.jsx(d.Group, { className: "bn-mt-suggestion-menu-item-label", children: o }) });
}), gt = T((r, t) => {
  const { className: n, isSelected: o, onClick: s, item: c, id: f, ...u } = r;
  return R(u), /* @__PURE__ */ l.jsxs(
    d.Group,
    {
      gap: 0,
      className: n,
      ref: t,
      id: f,
      role: "option",
      onClick: s,
      "aria-selected": o || void 0,
      children: [
        c.icon && /* @__PURE__ */ l.jsx(
          d.Group,
          {
            className: "bn-mt-suggestion-menu-item-section",
            "data-position": "left",
            children: c.icon
          }
        ),
        /* @__PURE__ */ l.jsxs(d.Stack, { gap: 0, className: "bn-mt-suggestion-menu-item-body", children: [
          /* @__PURE__ */ l.jsx(d.Text, { className: "bn-mt-suggestion-menu-item-title", children: c.title }),
          /* @__PURE__ */ l.jsx(d.Text, { className: "bn-mt-suggestion-menu-item-subtitle", children: c.subtext })
        ] }),
        c.badge && /* @__PURE__ */ l.jsx(
          d.Group,
          {
            "data-position": "right",
            className: "bn-mt-suggestion-menu-item-section",
            children: /* @__PURE__ */ l.jsx(d.Badge, { size: "xs", children: c.badge })
          }
        )
      ]
    }
  );
}), ht = T((r, t) => {
  const { className: n, children: o, ...s } = r;
  return R(s), /* @__PURE__ */ l.jsx(d.Group, { className: n, ref: t, children: o });
}), xt = T((r, t) => {
  const {
    className: n,
    children: o,
    // unused, using "dots" instead
    ...s
  } = r;
  return R(s), /* @__PURE__ */ l.jsx(d.Loader, { className: n, type: "dots", ref: t });
}), yt = T((r, t) => {
  const {
    className: n,
    children: o,
    draggable: s,
    onDragStart: c,
    onDragEnd: f,
    style: u,
    label: b,
    ...p
  } = r;
  return R(p, !1), /* @__PURE__ */ l.jsx(
    "button",
    {
      className: n,
      ref: t,
      "aria-label": b,
      draggable: s,
      onDragStart: c,
      onDragEnd: f,
      style: u,
      ...p,
      children: o
    }
  );
}), Le = T(
  (r, t) => {
    const { className: n, children: o, onMouseEnter: s, onMouseLeave: c, ...f } = r;
    R(f);
    const { ref: u, focused: b } = Nr(), p = Ir(b), y = Lr(t, u, p);
    return /* @__PURE__ */ l.jsx(
      d.Group,
      {
        className: n,
        ref: y,
        role: "toolbar",
        onMouseEnter: s,
        onMouseLeave: c,
        children: o
      }
    );
  }
), jt = (r) => /* @__PURE__ */ l.jsxs(d.Stack, { gap: 0, className: "bn-tooltip", children: [
  /* @__PURE__ */ l.jsx(d.Text, { size: "sm", children: r.mainTooltip }),
  r.secondaryTooltip && /* @__PURE__ */ l.jsx(d.Text, { size: "xs", children: r.secondaryTooltip })
] }), Ae = T(
  (r, t) => {
    const {
      className: n,
      children: o,
      mainTooltip: s,
      secondaryTooltip: c,
      icon: f,
      isSelected: u,
      isDisabled: b,
      onClick: p,
      label: y,
      ...w
    } = r;
    return R(w, !1), /* @__PURE__ */ l.jsx(
      d.Tooltip,
      {
        withinPortal: !1,
        label: /* @__PURE__ */ l.jsx(
          jt,
          {
            mainTooltip: s,
            secondaryTooltip: c
          }
        ),
        children: o ? /* @__PURE__ */ l.jsx(
          d.Button,
          {
            "aria-label": y,
            className: n,
            onMouseDown: (P) => {
              ae() && P.currentTarget.focus();
            },
            onClick: p,
            "aria-pressed": u,
            "data-selected": u || void 0,
            "data-test": s.slice(0, 1).toLowerCase() + s.replace(/\s+/g, "").slice(1),
            size: "xs",
            disabled: b || !1,
            ref: t,
            ...w,
            children: o
          }
        ) : /* @__PURE__ */ l.jsx(
          d.ActionIcon,
          {
            className: n,
            "aria-label": y,
            onMouseDown: (P) => {
              ae() && P.currentTarget.focus();
            },
            onClick: p,
            "aria-pressed": u,
            "data-selected": u || void 0,
            "data-test": s.slice(0, 1).toLowerCase() + s.replace(/\s+/g, "").slice(1),
            size: 30,
            disabled: b || !1,
            ref: t,
            ...w,
            children: f
          }
        )
      }
    );
  }
), Rt = T((r, t) => {
  const { className: n, items: o, isDisabled: s, ...c } = r;
  R(c);
  const f = o.filter((u) => u.isSelected)[0];
  return f ? /* @__PURE__ */ l.jsxs(
    d.Menu,
    {
      withinPortal: !1,
      transitionProps: {
        exitDuration: 0
      },
      disabled: s,
      middlewares: { flip: !0, shift: !0, inline: !1, size: !0 },
      children: [
        /* @__PURE__ */ l.jsx(d.Menu.Target, { children: /* @__PURE__ */ l.jsx(
          d.Button,
          {
            onMouseDown: (u) => {
              ae() && u.currentTarget.focus();
            },
            leftSection: f.icon,
            rightSection: /* @__PURE__ */ l.jsx(Jr, {}),
            size: "xs",
            variant: "subtle",
            disabled: s,
            children: f.text
          }
        ) }),
        /* @__PURE__ */ l.jsx(d.Menu.Dropdown, { className: n, ref: t, children: o.map((u) => /* @__PURE__ */ l.jsx(
          d.Menu.Item,
          {
            onClick: u.onClick,
            leftSection: u.icon,
            rightSection: u.isSelected ? /* @__PURE__ */ l.jsx(d.CheckIcon, { size: 10, className: "bn-tick-icon" }) : (
              // Ensures space for tick even if item isn't currently selected.
              /* @__PURE__ */ l.jsx("div", { className: "bn-tick-space" })
            ),
            disabled: u.isDisabled,
            children: u.text
          },
          u.text
        )) })
      ]
    }
  ) : null;
});
const x = [
  "#FFFFFF",
  "#EFEFEF",
  "#CFCFCF",
  "#AFAFAF",
  "#7F7F7F",
  "#3F3F3F",
  "#1F1F1F",
  "#161616",
  "#0F0F0F",
  "#000000"
], ze = {
  colors: {
    editor: {
      text: x[5],
      background: x[0]
    },
    menu: {
      text: x[5],
      background: x[0]
    },
    tooltip: {
      text: x[5],
      background: x[1]
    },
    hovered: {
      text: x[5],
      background: x[1]
    },
    selected: {
      text: x[0],
      background: x[5]
    },
    disabled: {
      text: x[3],
      background: x[1]
    },
    shadow: x[2],
    border: x[1],
    sideMenu: x[2],
    highlights: {
      gray: {
        text: "#9b9a97",
        background: "#ebeced"
      },
      brown: {
        text: "#64473a",
        background: "#e9e5e3"
      },
      red: {
        text: "#e03e3e",
        background: "#fbe4e4"
      },
      orange: {
        text: "#d9730d",
        background: "#f6e9d9"
      },
      yellow: {
        text: "#dfab01",
        background: "#fbf3db"
      },
      green: {
        text: "#4d6461",
        background: "#ddedea"
      },
      blue: {
        text: "#0b6e99",
        background: "#ddebf1"
      },
      purple: {
        text: "#6940a5",
        background: "#eae4f2"
      },
      pink: {
        text: "#ad1a72",
        background: "#f4dfeb"
      }
    }
  },
  borderRadius: 6,
  fontFamily: '"Inter", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Open Sans", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
}, Ot = {
  colors: {
    editor: {
      text: x[2],
      background: x[6]
    },
    menu: {
      text: x[2],
      background: x[6]
    },
    tooltip: {
      text: x[2],
      background: x[7]
    },
    hovered: {
      text: x[2],
      background: x[7]
    },
    selected: {
      text: x[2],
      background: x[8]
    },
    disabled: {
      text: x[5],
      background: x[7]
    },
    shadow: x[8],
    border: x[7],
    sideMenu: x[4],
    highlights: {
      gray: {
        text: "#bebdb8",
        background: "#9b9a97"
      },
      brown: {
        text: "#8e6552",
        background: "#64473a"
      },
      red: {
        text: "#ec4040",
        background: "#be3434"
      },
      orange: {
        text: "#e3790d",
        background: "#b7600a"
      },
      yellow: {
        text: "#dfab01",
        background: "#b58b00"
      },
      green: {
        text: "#6b8b87",
        background: "#4d6461"
      },
      blue: {
        text: "#0e87bc",
        background: "#0b6e99"
      },
      purple: {
        text: "#8552d7",
        background: "#6940a5"
      },
      pink: {
        text: "#da208f",
        background: "#ad1a72"
      }
    }
  },
  borderRadius: ze.borderRadius,
  fontFamily: ze.fontFamily
}, Tt = {
  FormattingToolbar: {
    Root: Le,
    Button: Ae,
    Select: Rt
  },
  FilePanel: {
    Root: at,
    Button: it,
    FileInput: st,
    TabPanel: lt,
    TextInput: ut
  },
  LinkToolbar: {
    Root: Le,
    Button: Ae
  },
  SideMenu: {
    Root: vt,
    Button: bt
  },
  SuggestionMenu: {
    Root: pt,
    Item: gt,
    EmptyItem: mt,
    Label: ht,
    Loader: xt
  },
  TableHandle: {
    Root: yt
  },
  Generic: {
    Form: {
      Root: (r) => /* @__PURE__ */ l.jsx("div", { children: r.children }),
      TextInput: Wr
    },
    Menu: {
      Root: Qr,
      Trigger: rt,
      Dropdown: tt,
      Divider: nt,
      Label: ot,
      Item: et
    },
    Popover: {
      Root: ct,
      Trigger: dt,
      Content: ft
    }
  }
}, Et = {
  // Removes button press effect
  activeClassName: ""
}, Ft = (r) => {
  const { theme: t, ...n } = r, o = Cr(), s = Dr(), c = (o == null ? void 0 : o.colorSchemePreference) || s, f = oe(
    (u) => {
      if (u && ($r(u), typeof t == "object")) {
        if ("light" in t && "dark" in t) {
          De(
            t[c === "dark" ? "dark" : "light"],
            u
          );
          return;
        }
        De(t, u);
        return;
      }
    },
    [c, t]
  );
  return /* @__PURE__ */ l.jsx(Or.Provider, { value: Tt, children: /* @__PURE__ */ l.jsx(
    Mr,
    {
      theme: Et,
      cssVariablesSelector: ".bn-container",
      children: /* @__PURE__ */ l.jsx(
        Fr,
        {
          theme: typeof t == "object" ? void 0 : t,
          ...n,
          ref: f
        }
      )
    }
  ) });
};
export {
  Ft as BlockNoteView,
  De as applyBlockNoteCSSVariablesFromTheme,
  Tt as components,
  Ot as darkDefaultTheme,
  x as defaultColorScheme,
  ze as lightDefaultTheme,
  $r as removeBlockNoteCSSVariables
};
//# sourceMappingURL=blocknote-mantine.js.map
